export default [
    {
        path: "with-transactions",
        name: "WithTransactions",
        meta:{
            permissionPath: 'coupons.goal.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "withTransactions" */ "@/views/storePanel/coupons/tabs/CouponsWithTransactions.vue"
            )
    },

    {
        path: "with-code",
        name: "WithCode",
        meta:{
            permissionPath: 'coupons.voucher.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "withCode" */ "@/views/storePanel/coupons/tabs/CouponsWithCode.vue"
            )
    },

    {
        path: "on-products",
        name: "OnProducts",
        meta:{
            permissionPath: 'coupons.product.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "onProducts" */ "@/views/storePanel/coupons/tabs/CouponsOnProducts.vue"
            )
    },

    // {
    //     path: "with-visits",
    //     name: "WithVisits",
    //     component: () =>
    //         import(
    //             /* webpackChunkName: "withVisits" */ "@/views/storePanel/coupons/tabs/CouponsWithVisits.vue"
    //         )
    // },

    {
        path: "with-discount",
        name: "WithDiscount",
        meta:{
            permissionPath: 'coupons.discount.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "withDiscount" */ "@/views/storePanel/coupons/tabs/CouponsWithDiscount.vue"
            )
    }
];
